import React, { useContext, useState } from 'react'
import { Box } from '@mui/system'
import styled from '@emotion/styled' 
import { Alert, Avatar, Button, Checkbox, FormControlLabel, Snackbar, TextField, Typography } from '@mui/material'
import { useFormik } from "formik";
import {useNavigate,redirect, useSearchParams} from 'react-router-dom'
import * as yup from "yup";
import api from '../../api/authApi'
import useAuth from '../../hooks/useAuth'
import SetCookie from '../../hooks/setCookie'
import AuthContext from '../../context/AuthContext';
const StyledForm=styled("form")(({theme})=>({
  padding:'20px',
  display:'flex',
  flexDirection:'column',
  gap:'20px',
}))
const BackGround=styled(Box)(({theme})=>({
   display:'flex',
   justifyContent:'center',
   alignItems:'center',
   padding:'30px',
   height:'100vh',
   width:'100vw',  
   background:theme.palette.secondary.lighter,
}))
const SignInCard=styled(Box)(({theme})=>({
    minWidth:'30%',
    minHeight:'60%',
    background:theme.palette.background.default,
    boxShadow: `0px 0px 7px ${theme.palette.background.shadow}`,
    borderRadius:'10px',
    padding:'10px',
}))
const LogoContainer = styled('span')(({theme})=>({
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
    justifyContent:'center',
    cursor:'pointer',
    span: {
        fontSize: '34px',
        fontWeight: '600',
    },
    marginLeft:'10px',
    paddingBottom:'40px',
    borderBottom: `0.5px solid ${theme.palette.third.light}`,
}))
const StyledTypography = styled(Box)(({theme})=>({
   display:'flex',
   width:'100%',
   justifyContent:'flex-end',
   textDecoration:'underline',
   paddingRight:'10px',
   cursor:'pointer',
   color:theme.palette.third.main,
   "&:hover":{
     color:theme.palette.secondary.main,

   }
}))

export default function SetPassword() {
const [wrong,setWrong]=useState(false)
const [searchParams, setSearchParams] = useSearchParams();
const __t=searchParams.get("__t");
const navigate=useNavigate()
const validationSchema = yup.object({
  password: yup
    .string("Enter your New Password")
    .required("New Password is required"),
  confirm: yup
    .string("Confirm your New Password")
    .oneOf([yup.ref("password"),null],"Passwords must match")
    .required("Confirming New Password is required"),
});
const formik = useFormik({
    initialValues: {
      password:'',
      confirm:'',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
     console.log(values.password,__t)
              api
          .patch("/resetPassword", {newPass:values.password,token:__t})
          .then((response) => {
           response.data.newPassword[0]===1?navigate('/success'):setWrong(true)
          })

    },
    
  });
  return (
    <BackGround>
        <SignInCard>
             <LogoContainer >
                <Avatar src="/images/aastulogo.png" sx={{ width: 40, height: 40 }} />
                <span>ASLMS</span>
            </LogoContainer>
            <StyledForm onSubmit={formik.handleSubmit}>
               <TextField
                fullWidth
                type="password"
                label="Password"
                id="password"
                name="password"
                onBlur={formik.handleBlur}
                value={formik.values.password}
                onChange={formik.handleChange}
                error={formik.errors.password && formik.touched.password }
                helperText={formik.touched.password && formik.errors.password}
              />
              <TextField
                fullWidth
                type="password"
                label="Confrim Password"
                id="confirm"
                name="confirm"
                value={formik.values.confirm}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                error={formik.errors.confirm && formik.touched.confirm }
                helperText={formik.touched.confirm && formik.errors.confirm}
              />
              <Button
               disabled={Boolean(formik.errors.password || formik.errors.confirm)}
              type="submit"
              size="large"
              sx={{
                   bgcolor:'secondary.main',
                   fontWeight: 400,
                   color:'#fff',
                  "&:hover":{
                   bgcolor:'secondary.hover',}, } }
              >
                Change Password
              </Button>
            </StyledForm>
        </SignInCard>
        <Snackbar open={wrong} autoHideDuration={6000} onClose={()=>setWrong(false)}>
            <Alert severity="error">There seems to be some problem with changing the password. Try Again!</Alert>
        </Snackbar>
    </BackGround>
  )
}
